import { Cell, Graph } from '@antv/x6'
import _ from 'lodash'

export const edgeAttrs = {
  line: {
    stroke: '#C2C8D5',
    strokeWidth: 4,
    targetMarker: 'block'
  }
}
export function addEdge({ metaData, graph }: { metaData: Cell.Metadata; graph: Graph }) {
  const edge = graph.addEdge({
    ...metaData,
    attrs: edgeAttrs
  })
  // 不要随意修改 label 的顺序，因为有其他地方是根据索引去获取 label 的
  edge.appendLabel({
    markup: [
      {
        tagName: 'circle',
        selector: 'bg'
      },
      {
        tagName: 'text',
        selector: 'txt'
      }
    ],
    attrs: {
      txt: {
        fill: '#fff',
        textAnchor: 'middle',
        textVerticalAnchor: 'middle',
        text: _.isEmpty(metaData.data.actionIds) ? '' : String(metaData.data.actionIds.length),
        cursor: 'pointer'
      },
      bg: {
        ref: 'txt',
        fill: '#F5AE00',
        refR: 6,
        refCx: 0,
        refCy: 0,
        cursor: 'pointer'
      }
    },
    position: {
      distance: 0.5
    }
  })
  edge.appendLabel({
    markup: [
      {
        tagName: 'circle',
        selector: 'bg'
      },
      {
        tagName: 'text',
        selector: 'txt'
      }
    ],
    attrs: {
      txt: {
        fill: '#fff',
        textAnchor: 'middle',
        textVerticalAnchor: 'middle',
        text: 'X',
        cursor: 'pointer',
        event: 'edge:delete'
      },
      bg: {
        ref: 'txt',
        fill: '#E23C39',
        refR: 4,
        refCx: 0,
        refCy: 0,
        cursor: 'pointer',
        event: 'edge:delete'
      }
    },
    position: {
      distance: 0.7
    }
  })
  return edge
}
